import technicist from './technicist'

export default technicist
